import React, { useState } from 'react';
import { Grid, TextField, Button, Typography, Paper, Box } from '@mui/material';
import { useAuth } from '../../context';
import backgroundImage from '../../../image/OIG.jpeg';

const container = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

export const Login = ({ children }) => {
  const { isAuthenticated, login } = useAuth();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      login(username, password);
    } catch (error) {
      console.error(error);
    }
  };

  if (isAuthenticated) return <>{children}</>;

  return (
    <Box sx={container}>
      <Paper elevation={3} sx={{ padding: 2, minWidth: 300 }}>
        <Typography variant="h5" gutterBottom>
          Tela de Login
        </Typography>
        <form onSubmit={handleLogin}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Login"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Senha"
                value={password}
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Login
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};
